module.exports = __webpack_public_path__ + "static/media/zapper.1e315e8e.svg";